module.exports = __webpack_public_path__ + "static/img/travel2.b5525f27.png";